var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.not_found)?_c('v-btn',{attrs:{"icon":"","small":"","color":"error","loading":_vm.loading},on:{"click":function($event){return _vm.deleteone()}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-delete")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }